import React from "react";
import {useLanguage} from "../../../hooks/LanguageContext";

const ShippingPrices = () => {
	const { direction } = useLanguage();

	// Dynamic text based on direction
	const headingText = direction === "rtl" ? "اكتشف أسعار الشحن لدينا" : "Discover Our Shipping Prices";
	const subText =
		direction === "rtl"
			? "اضغط على الزر لمعرفة أسعار الشحن المتاحة (الاسعار المعروضة لا تشمل ضريبة القيمة المضافة)."
			: "Click the button to see available shipping prices (The displayed prices do not include VAT).";
	const buttonText = direction === "rtl" ? "عرض الأسعار" : "Show Prices";

	const handleOnClick = () => {
		window.open("https://app.alfayzgroup.com/tracking/show/price", "_blank");
	};

	return (
		<div className={`md:w-[1102px] w-full flex flex-col items-start gap-4 md:gap-8 z-[2] ${direction === "rtl" ? "text-right" : "text-left"}`}>
			<h3 className="headline-3-ar text-grayscale-600">{headingText}</h3>

			<div className={`flex items-baseline ${direction === "rtl" ? "justify-start" : "justify-end"} gap-[13px]`}>
				<span className="md:w-[12px] md:h-[12px] w-[10px] h-[10px] bg-primary-700 rounded-full"></span>
				<span className="text-grayscale-500 font-bold md:text-xl lg:text-2xl">{subText}</span>
			</div>

			{/* Button to navigate to shipping prices */}
			<a href="https://app.alfayzgroup.com/tracking/show/price" target="_blank" rel="noreferrer"
			className="rounded-[10px] lg:min-w-[180px] text-white font-bold whitespace-nowrap min-w-[120px] md:min-h-[50px] min-h-[44px] flex items-center justify-center gap-[10px] md:py-[13px] py-[5px] md:px-[26px] px-[16px] bg-primary-700 hover:bg-primary-700 transition-colors delay-100 ease-in-out">
				{buttonText}
			</a>

		</div>
	);
};

export default ShippingPrices;
